import React, { useRef } from "react";
import PricingCard from "./PricingCard";
import "./PricingCards.css";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const pricingData = [
  {
    title: "Matematika - viša razina - 50 sat",
    description: "25 termina od 2 sunčana sata",
    price: "525",
  },
  {
    title: "Matematika - osnovna razina – 42 sata",
    description: "21 termin od 2 sunčana sata",
    price: "441",
  },
  {
    title: "Hrvatski jezik – 42 sata",
    description: "21 termina od 2 sunčana sata",
    price: "441",
  },
];

const PricingCards = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = React.useState(false);
  const [startX, setStartX] = React.useState(0);
  const [scrollPosition, setScrollPosition] = React.useState(0);

  const onMouseDown = (e: React.MouseEvent) => {
    if (scrollRef.current) {
      e.preventDefault();
      setIsDragging(true);
      setStartX(e.pageX - scrollRef.current.offsetLeft);
      setScrollPosition(scrollRef.current.scrollLeft);
    }
  };

  const onMouseUp = () => {
    setIsDragging(false);
  };

  const onMouseMove = (e: React.MouseEvent) => {
    if (!isDragging || !scrollRef.current) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2; // The 2 is a speed multiplier
    scrollRef.current.scrollLeft = scrollPosition - walk;
  };

  const onMouseLeave = () => {
    setIsDragging(false);
  };

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  return (
    <>
      <div className="d-flex align-items-center">
        <div>
          <IoIosArrowBack
            size={40}
            className="scroll-button"
            onClick={scrollLeft}
          />
        </div>

        <div
          ref={scrollRef}
          className={`pb-2 text-center d-flex overflow-x-scroll ${
            isDragging ? "grabbing unselectable" : ""
          }`}
          onMouseDown={onMouseDown}
          onMouseUp={onMouseUp}
          onMouseLeave={onMouseLeave}
          onMouseMove={onMouseMove}
        >
          {pricingData.map((pricingCard, index) => (
            <PricingCard
              key={index}
              title={pricingCard.title}
              description={pricingCard.description}
              price={pricingCard.price}
            />
          ))}
        </div>

        <div>
          <IoIosArrowForward
            size={40}
            className="scroll-button"
            onClick={scrollRight}
          />
        </div>
      </div>
      <p className="mx-5">
        <em>U cijenu je uračunat iznos PDV-a. Mogućnost plaćanja na rate.</em>
      </p>
    </>
  );
};

export default PricingCards;
